<template>
  <div class="vehicle-type">
    <MenuTitle :text="title" />

    <div class="container">
      <div class="row">
        <div
            v-for="vehicleType in vehicleTypes"
            :key="vehicleType.id"
            :id="`categoria-input-${vehicleType.id}`"
            class="option"
            @click="selectVehicleType(vehicleType)"
        >
          <img :src="iconSrc(vehicleType)" :width="47" :height="37" />
          <span :style="`color:${isVehicleTypeSelected(vehicleType) ? '#FF7A00' : '#6f6f6f'}`">
            {{ vehicleType.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuTitle from "@/components/typographies/MenuTitle.vue";
import { clearAllFiltersExcept, clearAllDrawers } from "@/helpers/queryParamsHelper";

import carIcon from "@/assets/icons/car-icon.svg";
import carIconPrimary from "@/assets/icons/car-icon-primary-color.svg";
import motorbikeIcon from "@/assets/icons/motorbike-icon.svg";
import motorbikeIconPrimary from "@/assets/icons/motorbike-icon-primary-color.svg";
import truckIcon from "@/assets/icons/truck-icon.svg";
import truckIconPrimary from "@/assets/icons/truck-icon-primary-color.svg";
import semImagem from "@/assets/sem-imagem.png";

export default {
  name: "VehicleType",
  components: { MenuTitle },
  props: {
    title: String,
    params: Object,
    vehiclesTypeSelected: Array,
    category: Object,
    setParam: String,
    clear: { required: false, type: String },
  },
  data() {
    return {
      vehicleTypes: [
        { id: "carros",  title: "Carros",  icon_default: "car-icon",        icon_selected: "car-icon-primary-color" },
        { id: "motos",   title: "Motos",   icon_default: "motorbike-icon",   icon_selected: "motorbike-icon-primary-color" },
        { id: "pesados", title: "Pesados", icon_default: "truck-icon",       icon_selected: "truck-icon-primary-color" },
      ],
    };
  },
  methods: {
    iconSrc(vehicleType) {
      const isSelected = this.isVehicleTypeSelected(vehicleType);
      const name = isSelected ? vehicleType.icon_selected : vehicleType.icon_default;

      const iconMap = {
        'car-icon': carIcon,
        'car-icon-primary-color': carIconPrimary,
        'motorbike-icon': motorbikeIcon,
        'motorbike-icon-primary-color': motorbikeIconPrimary,
        'truck-icon': truckIcon,
        'truck-icon-primary-color': truckIconPrimary
      };

      return iconMap[name] || semImagem;
    },
    selectVehicleType(vehicleType) {
      if (this.isVehicleTypeSelected(vehicleType)) {
        clearAllFiltersExcept(this.$store, this.setParam, {});
        clearAllDrawers(this.$store);
        return;
      }
      
      const newCategory = [{ id: vehicleType.id, name: vehicleType.title }];
      const filtersToKeep = { category: newCategory };
      if (this.params && this.params.campaign) {
        filtersToKeep.campaign = this.params.campaign;
      }
      
      clearAllFiltersExcept(this.$store, this.setParam, filtersToKeep);
      clearAllDrawers(this.$store);
    },
    
    isVehicleTypeSelected(vehicleType) {
      if (!this.vehiclesTypeSelected || this.vehiclesTypeSelected.length === 0) {
        return false;
      }
      return this.vehiclesTypeSelected.some(
          v => (v.id ?? v) === vehicleType.id
      );
    },
  },
};
</script>

<style scoped>
.container {
  flex: 1;
  padding: 0;
  margin-top: 12px;
  margin-bottom: 24px;
}

.row {
  direction: row;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.option {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.option span {
  font-family: "Lexend Deca";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #6f6f6f;
}
</style>
